// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "*[data-v-7ef02f58]{margin:0;padding:0}.container-page[data-v-7ef02f58]{width:80%;margin:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
